import { connect } from 'react-redux';
import { onFieldChange, login, resetPage, showLoginForm } from '../../actions/LoginPage';
import LoginPage from './LoginPage';

const mapsStateToProps = state => ({
	pageProps: state.loginPageReducer
});

const mapsDispatchToProps = dispatch => ({
	onFieldChange(fieldName, fieldValue) {
		dispatch(onFieldChange(fieldName, fieldValue));
	},
	login(opts) {
		dispatch(login(opts));
	},
	resetPage() {
		dispatch(resetPage());
	},
	showLoginForm(opts) {
		dispatch(showLoginForm(opts));
	}
});

export default connect(
	mapsStateToProps,
	mapsDispatchToProps
)(LoginPage);
